import React from "react";

import { Box, Typography, Button, Stack, Tooltip } from "@mui/material";

import AddRoundedIcon from "@mui/icons-material/AddRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";

import { useTranslation } from "react-i18next";

const EmployeeHeader = ({ onAddEmployee, onRefresh, loading = false }) => {
  const { t } = useTranslation("UserManagement");

  return (
    <Box
      sx={{
        mb: 3,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      {/* LEFT SIDE */}
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            width: 55,
            height: 55,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "primary.main",
            color: "white",
          }}
        >
          <GroupsRoundedIcon fontSize="large" />
        </Box>

        <Box>
          <Typography variant="h5" fontWeight={700}>
            {t("EmployeeManagement")}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {t("ManageEmployeesDescription")}
          </Typography>
        </Box>
      </Stack>

      {/* ACTIONS */}
      <Stack direction="row" spacing={1.5}>
        <Tooltip title={t("Refresh")}>
          <Button
            variant="outlined"
            startIcon={<RefreshRoundedIcon />}
            onClick={onRefresh}
            disabled={loading}
          >
            {t("Refresh")}
          </Button>
        </Tooltip>

        <Button
          variant="contained"
          startIcon={<AddRoundedIcon />}
          onClick={onAddEmployee}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            px: 3,
          }}
        >
          {t("AddEmployee")}
        </Button>
      </Stack>
    </Box>
  );
};

export default EmployeeHeader;
